import React from 'react';
import { inputs } from '@ecosystem/newron-design-system';
import type { NotificationPreference } from './types';
import './NotificationPreferencesSection.css';
export type NotificationPreferencesSectionProps = {
  title: string;
  type: string;
  preferences?: NotificationPreference;
  onChange?: (preferences: NotificationPreference, isValid?: boolean) => void;
  email?: boolean;
  push?: boolean;
  children?: React.ReactNode;
  emptyPrompt?: string;
  checkBoxTestId?: string;
};

function NotificationPreferencesSection({
  preferences = { type: '', settings: { email: false, push: false } },
  onChange,
  email = false,
  push = false,
  children,
  title,
  type,
  checkBoxTestId,
}: NotificationPreferencesSectionProps) {
  const { Checkbox, CheckboxState } = inputs;

  const handleChange = (name: 'email' | 'push', state: 'checked' | 'unchecked' | 'indeterminate') => {
    let updated = { ...preferences };

    updated = {
      type,
      settings: { ...(updated.settings || { email: false, push: false }), [name]: state === 'checked' ? true : false },
      context: { ...(updated.context || {}) },
    };

    onChange(updated);
  };

  return (
    <div className="pl-8 pr-7 mb-6">
      <div className={`flex justify-between`}>
        <div className=" py-2 text-lg ">{title}</div>
        <div className="flex justify-between preferences-checkboxes pr-1">
          {push && (
            <div className="py-2">
              <Checkbox
                onChange={state => handleChange('push', state)}
                state={preferences?.settings?.push ? CheckboxState.CHECKED : CheckboxState.UNCHECKED}
                testId={`${checkBoxTestId}-checkbox-push`}
                disabled={type === 'collections-download'}
              />
            </div>
          )}
          {email && (
            <div className="py-2">
              <Checkbox
                onChange={state => handleChange('email', state)}
                state={preferences?.settings?.email ? CheckboxState.CHECKED : CheckboxState.UNCHECKED}
                testId={`${checkBoxTestId}-checkbox-email`}
              />
            </div>
          )}
        </div>
      </div>
      {children}
    </div>
  );
}

export { NotificationPreferencesSection };
